import { render, staticRenderFns } from "./OfficeBizEdit.vue?vue&type=template&id=253aa048&scoped=true&"
import script from "./OfficeBizEdit.vue?vue&type=script&lang=js&"
export * from "./OfficeBizEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253aa048",
  null
  
)

export default component.exports